import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

const CategoryNavbarBundle = ({ selectedCategory, setSelectedCategory, category, setcategory, totalItems, categoryData,tags,settags,availableTags }) => {
  const scrollRef = useRef(null);
  console.log("cat data", categoryData)
  let isDragging = false;
  let startX;
  let scrollLeft;

  const tagClass = (active) =>
  `relative px-4 py-1.5 rounded-full text-[12px] md:text-[14px]
  border transition-all duration-200 whitespace-nowrap
  ${
    active
      ? "text-white border-transparent bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] shadow-[0_0_12px_rgba(147,67,255,0.45)]"
      : "bg-black text-white border-white/30 hover:text-white hover:border-transparent hover:bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]"
  }`;





  const handleMouseDown = (e) => {
    isDragging = true;
    startX = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft = scrollRef.current.scrollLeft;
    scrollRef.current.classList.add('dragging');
  };

  const handleMouseLeave = () => {
    isDragging = false;
    scrollRef.current.classList.remove('dragging');
  };

  const handleMouseUp = () => {
    isDragging = false;
    scrollRef.current.classList.remove('dragging');
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // Adjust scroll speed here
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="w-full bg-transparent ">
      <nav
        ref={scrollRef}
        className="category-scroll text-white flex flex-nowrap items-center px-4 pl-0 py-2 mb-2 overflow-x-auto whitespace-nowrap space-x-4 cursor-grab"
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        <button
          type="button"
          onClick={() => {
            setSelectedCategory("All") 
            setcategory("")
            settags('')
          }}
          className={tagClass(selectedCategory === "All")}

        >All
          {selectedCategory === "All" && totalItems && (
            <span className="ml-1 inline-flex items-center justify-center px-2 py-0.5
          text-xs font-semibold bg-white text-black rounded-full">
            {totalItems}
          </span>

          )}
        </button>
          
        {Array.isArray(availableTags) && availableTags.length > 0 && (
            availableTags.map((tag) => (
                <button
                key={tag}
                onClick={() => {
                    settags(tag);
                    setcategory("");
                    setSelectedCategory("");
                }}
                className={tagClass(tags === tag)}
                >
                {tag}
                {tags === tag && totalItems > 0 && (
                    <span className="ml-1 px-2 py-0.5 text-xs bg-white text-black rounded-full">
                    {totalItems}
                    </span>
                )}
                </button>
            ))
            )}

        


        {/* {
          (categoryData) && categoryData.map((item) => {
            return <>
              <button type='button' onClick={()=>{
                setcategory(item._id)
                setSelectedCategory("")
                settags('')
              }} 
               className={tagClass(category === item._id)}

              >
                {item.category_name} {category ===item._id && totalItems && (
            <span className="ml-1 inline-flex items-center justify-center px-2 py-0.5
          text-xs font-semibold bg-white text-black rounded-full">
              {totalItems}
            </span>
          )}
              </button>
            </>
          })
        } */}

        {/* <button
          type="button"
          onClick={() => {
            // setSelectedCategory("Today")
            settags('Chatgpt')
            setcategory("")
            setSelectedCategory("")
          }}
          className={tagClass(tags === "Chatgpt")}

        >Chatgpt
          {tags === "Chatgpt" && totalItems && (
            <span className="ml-1 inline-flex items-center justify-center px-2 py-0.5
          text-xs font-semibold bg-white text-black rounded-full">
              {totalItems}
            </span>
          )}
        </button> */}

        {/* <button
          type="button"
          onClick={() => {
            // setSelectedCategory("Today")
            settags('Gemini')
            setcategory("")
            setSelectedCategory("")
          }}
         className={tagClass(tags === "Gemini")}

        >Gemini
          {tags === "Gemini" && totalItems && (
            <span className="ml-1 inline-flex items-center justify-center px-2 py-0.5
          text-xs font-semibold bg-white text-black rounded-full">
              {totalItems}
            </span>
          )}
        </button> */}

      </nav>
    </div>
  );
};

export default CategoryNavbarBundle;